var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"framePlan"},[_c('ViewPlan',{staticClass:"h",attrs:{"types":0}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }